import React, {useState, useEffect} from 'react';
import { VehicleIdPart } from './VehicleIdPart'
import { ContainerIdPart } from './ContainerIdPart'

// Contains what the paying party is paying for. 
// https://goshakkk.name/array-form-inputs/
const ChoosePaymentItemsSection = (props) => {
    
    const [vehicleIdInputList, UpdateVehicleIdList] = useState([{vin: "", bookingNum: ""}]);
    const [containerIdInputList, UpdateContainerIdList] = useState([{bookingNum: "", ladingNum: ""}]);
    
    useEffect(() => {
        var vehicleList = [];
        var containerList = [];
        if(props.paymentItemType === "vehicle" || props.paymentItemType === "both"){
            vehicleList = vehicleIdInputList;
        }
        if(props.paymentItemType === "container" || props.paymentItemType === "both"){
            containerList = containerIdInputList;
        }
        
        props.onVehicleUpdate(vehicleList);
        props.onContainerUpdate(containerList);
    }, [props.paymentItemType]);



    const AddVehicleIdInput = () => {        
        var vList = [...vehicleIdInputList];
        if(vList.length < props.maxVehicles){
            vList.push({vin: "", bookingNum: ""});
        }
        UpdateVehicleIdList(vList);
        props.onVehicleUpdate(vList);
    }    
    const RemoveLastVehicle = () => {
        var vList = [...vehicleIdInputList];
        if(vList.length > 0){
            vList = vList.splice(0,vList.length-1)
        }
        UpdateVehicleIdList(vList);
        props.onVehicleUpdate(vList);
    }    
    const updateVehicleData = (id, key, value) => {
        var vList = [...vehicleIdInputList];
        if(id >= 0 && id < vList.length){
            vList[id][key] = value;
        }
        UpdateVehicleIdList(vList);   
        props.onVehicleUpdate(vList);
    }

    const AddContainerIdInput = () => {         
        var cList = [...containerIdInputList];
        if(cList.length < props.maxContainers){
            cList.push({bookingNum: "", ladingNum: ""});
        }
        UpdateContainerIdList(cList);
        props.onContainerUpdate(cList);
    }
    const RemoveLastContainer = () => {
        var cList = [...containerIdInputList];
        if(cList.length > 0){
            cList = cList.splice(0,cList.length-1)
        }
        UpdateContainerIdList(cList);        
        props.onContainerUpdate(cList);
    }    
    const updateContainerData = (id, key, value) => {
        var cList = [...containerIdInputList];
        if(id >= 0 && id < cList.length){
            cList[id][key] = value;
        }
        UpdateContainerIdList(cList);     
        props.onContainerUpdate(cList);   
    }

    var lineBreakBetweenVehicleAndContainer;
    if(vehicleIdInputList.length > 0 && containerIdInputList.length > 0){
        lineBreakBetweenVehicleAndContainer = <div className="col-12">
            <hr />
        </div>
    }
    return (        
        <div className="row mt-2">
            <div className="col-12 m-2">
                Please add all of the freight that you are paying for below:
            </div>

            {(props.paymentItemType === "vehicle" || props.paymentItemType === "both")
            && 
            <div className="col-12">
                <div className="row">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-auto ml-auto p-2">
                                <button type="button" className="btn btn-success" 
                                    onClick = {(e) => {  e.stopPropagation();
                                                AddVehicleIdInput();
                                            }}>Add Vehicle</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">    
                            <div className="col-auto mr-auto p-2">
                                <button type="button" className="btn btn-danger mr-auto"
                                    onClick = {(e) => {  e.stopPropagation(); 
                                                RemoveLastVehicle()
                                            }}>Remove Vehicle {vehicleIdInputList.numVehicles}</button>                                
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {vehicleIdInputList.length > 0 && <span>{vehicleIdInputList.length} Vehicle(s)</span>}
                    </div>
                    <div className="w-100"></div>
                    {vehicleIdInputList.map((values, index) => 
                        <div key={index} className="col-sm-12 col-md-6">
                            <div className="card border border-muted m-1 p-2">
                                <div className="row">
                                    <div className="col"><strong>Vehicle {index+1}</strong>
                                    </div>  
                                </div>
                                <VehicleIdPart id={index} vin={values.vin} bookingNum={values.bookingNum} 
                                    onUpdate={updateVehicleData}/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            }

            {(props.paymentItemType === "container" || props.paymentItemType === "both")
            && 
            <div className="col-12">
                <div className="row">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-auto ml-auto p-2">
                                <button type="button" className="btn btn-success" onClick=
                                    { (e) => {  e.stopPropagation();
                                                AddContainerIdInput();
                                            }}>Add Container</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">    
                            <div className="col-auto mr-auto p-2">
                                <button type="button" className="btn btn-danger" onClick=
                                { (e) => {  e.stopPropagation();
                                            RemoveLastContainer();
                                        }}>Remove Container</button>
                            </div>
                        </div>
                    </div>                    
                    <div className="col-12">
                        {containerIdInputList.length > 0 && <span>{containerIdInputList.length} Container(s)</span>}
                    </div>
                    {containerIdInputList.map((values, index) =>            
                        <div key={index} className="col-sm-12 col-md-6">
                            <div className="card border border-muted m-1 p-2">
                                <div className="row mb-1">
                                    <div className="col"><strong>Container {index+1}</strong>
                                    </div>
                                </div>
                                <ContainerIdPart id={index} bookingNum={values.bookingNum} ladingNum={values.ladingNum} 
                                    onUpdate={updateContainerData}/>
                            </div>
                        </div>
                    )}    
                </div>
            </div>
            }
        </div>
    );
}

export { ChoosePaymentItemsSection }